export const agedByOptions = [
  { name: 'Due Date', value: 'due_date' },
  { name: 'Invoice Date', value: 'invoice_date' },
  { name: 'Posting Date', value: 'posting_date' },
];
